import { DonatePanel } from "@components/donate/DonatePanel"
import { tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { useAppData } from "eddev/hooks"

export const meta: BlockMeta = {
  title: "Gift Card",
  category: "embeds",
  icon: "carrot",
  description: "A panel for purchasing a gift card",
  keywords: ["voucher"],
  tags: ["#subpage-layout"],
  flags: {
    fullWidth: true,
    marginRule: "large-card",
  },
  blockStyles: [
    {
      label: "Medium",
      name: "medium",
      isDefault: true,
    },
    {
      label: "Large",
      name: "large",
    },
    {
      label: "Small",
      name: "small",
    },
  ],
}

export default defineBlock("tickets/gift-card", (props) => {
  let voucherHash = useAppData((data) => data.sffSettings?.donations?.ferveGiftVoucherHash)

  if (props.ferveHash) {
    voucherHash = props.ferveHash
  }

  const styles = createStyles({
    layout: props.blockStyle || "large",
  })

  return (
    <div>
      <div className={styles.base()}>
        <div className={styles.column()}>
          <DonatePanel
            title={<EditableText store="title" defaultValue="Give the Gift of Cinema" plainText />}
            description={<EditableText store="description" placeholder="Enter a description..." plainText />}
            label={
              <EditableText store="label" defaultValue="Select your gift voucher amount or enter your own:" plainText />
            }
            ferveHash={voucherHash!}
            amounts={props.giftAmounts?.map((row) => row?.amount!)}
            readMoreLink={
              props.readMoreLink?.url
                ? {
                    title: props.readMoreLink.title!,
                    url: props.readMoreLink.url!,
                    target: props.readMoreLink.target!,
                  }
                : undefined
            }
            isGiftCard
          />
        </div>
      </div>
    </div>
  )
})

const createStyles = tv({
  base: "grid-auto",
  slots: {
    column: "",
  },
  variants: {
    layout: {
      medium: {
        column: "col-span-12 lg:col-1-10",
      },
      large: {
        column: "col-span-12",
      },
      small: {
        column: "col-subpage-content-grid",
      },
    },
  },
})
